import { AdminJobPhotoManager } from "@/components/AdminJobPhotoManager";
import { useSearchParams } from "react-router-dom";

const JobPhotoManagement = () => {
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get('job') ?? "cf25f3d5";

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="border-b bg-card">
        <div className="container mx-auto px-4 py-6">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground mb-2">
              Job Photo Management
            </h1>
            <p className="text-muted-foreground">
              Manage photos for job ID: <code className="bg-muted px-2 py-1 rounded">{jobId}</code>
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-8">
        <AdminJobPhotoManager jobId={jobId} />
      </div>
    </div>
  );
};

export default JobPhotoManagement;